import React, { useEffect, useMemo, useState } from "react";
import "./ValueWithMaxInput.css";

/**
 * Dual numeric input for current value and max value, rendered as `current / max`.
 */
const ValueWithMaxInput = ({
  currentValue = "",
  maxValue = "",
  onChange = () => {},
  disable = false,
  maxEditable = true,
  currentPlaceholder = "",
  maxPlaceholder = "",
  name = "",
}) => {
  const [current, setCurrent] = useState(currentValue ?? "");
  const [max, setMax] = useState(maxValue ?? "");

  useEffect(() => {
    setCurrent(currentValue ?? "");
  }, [currentValue]);

  useEffect(() => {
    setMax(maxValue ?? "");
  }, [maxValue]);

  const parsedMax = useMemo(() => {
    const val = parseFloat(max);
    return Number.isFinite(val) ? val : null;
  }, [max]);

  const handleCurrentChange = e => {
    const value = e.target.value;
    const numeric = parseFloat(value);
    if (parsedMax !== null && Number.isFinite(numeric) && numeric > parsedMax) {
      setCurrent(parsedMax.toString());
      onChange({ current: parsedMax.toString(), max });
      return;
    }
    setCurrent(value);
    onChange({ current: value, max });
  };

  const handleMaxChange = e => {
    const value = e.target.value;
    const numeric = parseFloat(value);
    setMax(value);

    // Clamp current if it exceeds new max
    if (Number.isFinite(numeric)) {
      const currentNumeric = parseFloat(current);
      if (Number.isFinite(currentNumeric) && currentNumeric > numeric) {
        setCurrent(value);
        onChange({ current: value, max: value });
        return;
      }
    }

    onChange({ current, max: value });
  };

  return (
    <div
      className={`value-with-max-input ${disable ? "disabled" : ""}`}
      data-name={name}
    >
      <input
        type="number"
        step="0.1"
        min="0"
        value={current}
        onChange={handleCurrentChange}
        placeholder={currentPlaceholder}
        disabled={disable}
        className="value-with-max-field"
      />
      <div className="value-with-max-separator">/</div>
      <input
        type="number"
        step="0.1"
        min="0"
        value={max}
        onChange={handleMaxChange}
        placeholder={maxPlaceholder}
        disabled={disable || !maxEditable}
        className="value-with-max-field"
      />
    </div>
  );
};

export default ValueWithMaxInput;
